import { notificationsKey } from 'queryKeys';

const NOTIFICATIONS_SETTINGS = 'notificationsNotifications';

const notficationsSettingsQuery = notificationsKey.query(
  NOTIFICATIONS_SETTINGS
);

export const notificationSettings = notficationsSettingsQuery.exact();

export const mutations = notficationsSettingsQuery.mutations();

export const update = mutations.update();
